import React, { Component, Fragment } from 'react';
import { ProductGroupMarketingComponent } from '../../../../products/components/ProductGroupMarketingComponent';
import { FormattedDate } from 'react-intl';
import { ShipmentStatus } from '../../../../orders/order';
import ShipViaComponent from './ShipViaComponent';
import { Tooltip } from 'reactstrap';
import { formatDateLongMonth } from '@ami/react/core';
import SerialNumberModal from './SerialNumberModal';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { ProductConfiguration } from '../../../../products/productConfiguration';
import AddCustomerApprovalModal from './AddCustomerApprovalModal';
import { appConfig } from '@ami/react/core';
import { isAmiUserAuthorizedToManageOrders, isAmiUserAuthorizedToManageCustomerApprovals } from '../../../../authorization/amiPermissions';

class ShipmentInformation extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      tooltipOpen: false,
    };
  }

  toggle() {
    this.setState({ tooltipOpen: !this.state.tooltipOpen });
  }

  render() {
    const { shipment, lineItem } = this.props;
    const hasDateChanged =
      lineItem.originalShipmentDate !== shipment.shipmentDate;
    return (
      <div className="col-12 col-sm-2">
        <div className="label">Completion Date</div>
        <strong>
          <FormattedDate
            value={shipment.shipmentDate}
            year="numeric"
            month="long"
            day="2-digit"
            timeZone="utc"
          />
        </strong>
        <br />
        {shipment.status === ShipmentStatus.Shipped && (
          <span className="badge text-bg-success">Shipped</span>
        )}
        {shipment.status === ShipmentStatus.Confirmed && (
          <span className="badge text-bg-primary">Confirmed</span>
        )}
        {shipment.status === ShipmentStatus.Scheduled && hasDateChanged && (
          <Fragment>
            <span
              id={'RevisedProduct-' + lineItem.id}
              className="badge"
              style={{ backgroundColor: 'orange', color: 'black' }}
            >
              Revised
            </span>
            <Tooltip
              isOpen={this.state.tooltipOpen}
              target={'RevisedProduct-' + lineItem.id}
              toggle={this.toggle}
            >
              Original shipping date:
              <br />
              {formatDateLongMonth(lineItem.originalShipmentDate)}
            </Tooltip>
          </Fragment>
        )}
        {shipment.status === ShipmentStatus.Scheduled && !hasDateChanged && (
          <span className="badge text-bg-secondary">Scheduled</span>
        )}
      </div>
    );
  }
}

const OrderProductOptionComponent = ({ partNumber, name, description }) => {
  return (
    <div className='container'>
      <div className="row row-cols-auto">
        {partNumber && (
          <Fragment>
            <div className="col ps-0 pe-0 text-nowrap">{partNumber}</div>
            <div className='col ps-1 pe-1'>-</div>
          </Fragment>
        )}
        <div className="col ps-0 pe-0 text-break-line">
          <div className='text-nowrap'>{name}</div>
          <div>{description}</div>
        </div>
      </div>
    </div>
  );
};

class OrderShipmentProduct extends React.Component {
  constructor(props) {
    super(props);
    this.onEditSerialNumber.bind();
    this.state = {
      showModal: false,
      idx: 0,
      serialNumber: '',
      showModalAddCustomerApproval: false,
    };
  }
  static propTypes = {
    lineItem: PropTypes.any.isRequired,
    shipment: PropTypes.any,
    productConfiguration: PropTypes.instanceOf(ProductConfiguration).isRequired,
    order: PropTypes.any,
    loadOrder: PropTypes.func,
    onNewTask: PropTypes.func,
    enabledAddCustomerApproval: PropTypes.bool.isRequired,
    enabledNewTask: PropTypes.bool.isRequired,
  };

  onEditSerialNumber = (idx, serialNumber) => {
    this.setState({ showModal: true, idx: idx, serialNumber: serialNumber });
  };

  newAmiTask = (id) => {
    this.props.onNewTask(id);
  };

  hide = () => this.setState({ showModal: false });

  onAddCustomerApproval = () => {
    this.setState({ showModalAddCustomerApproval: true });
  };

  hideAddCustomerApprobal = () =>
    this.setState({ showModalAddCustomerApproval: false });

  render() {
    const {
      lineItem,
      productConfiguration,
      shipment,
      order,
      loadOrder,
      onNewTask,
      enabledAddCustomerApproval,
      enabledNewTask,
    } = this.props;
    const { showModal, idx, serialNumber, showModalAddCustomerApproval } =
      this.state;

    const paintColor = lineItem.paintColor || lineItem.inventoryItemPaintColor;

    return (
      <div className="row">
        <div className={`col-12 col-sm-${shipment ? '5' : '6'}`}>
          <div className="row">
            {lineItem.imageUrl && (
              <div className="col-12 offset-3 offset-md-0 col-md-3 align-self-start">
                <img
                  src={lineItem.imageUrl}
                  className="product-image img-fluid me-2"
                  alt={lineItem.name}
                />
                <ProductGroupMarketingComponent
                  marketing={lineItem.marketing}
                  productConfiguration={productConfiguration}
                />
              </div>
            )}
            <div className="col-12 col-md-9">
              <div className="line-item-name">
                {lineItem.name}{' '}
                {enabledNewTask && onNewTask && (
                  <Button
                    title="New Task"
                    className="btn btn-outline-primary btn-xs ms-1"
                    onClick={() => this.newAmiTask(lineItem.id)}
                  >
                    New Task
                  </Button>
                )}{' '}
                {enabledAddCustomerApproval && isAmiUserAuthorizedToManageCustomerApprovals() && (
                  <Button
                    title="Add Approval"
                    className="btn btn-outline-primary btn-xs ms-1"
                    onClick={() => this.onAddCustomerApproval()}
                  >
                    Add Approval
                  </Button>
                )}{' '}
                {showModalAddCustomerApproval && (
                  <AddCustomerApprovalModal
                    show={showModalAddCustomerApproval}
                    onHide={this.hideAddCustomerApprobal}
                    idx={idx}
                    serialNumber={serialNumber}
                    order={order != null ? order : null}
                    orderLineItem={lineItem}
                    onChanged={loadOrder}
                  />
                )}
              </div>
              <div className="line-item-details">{lineItem.details}</div>
              {lineItem.dimensions && (
                <ul className="line-item-dimensions">
                  {lineItem.dimensions.map((x, idx) => (
                    <li key={idx}>
                      {x.name}: {x.value}
                    </li>
                  ))}
                </ul>
              )}
              {lineItem.lugging && <span>Lugging: {lineItem.lugging}</span>}
              {paintColor && <div>Paint: {paintColor}</div>}
              {lineItem.options &&
                lineItem.options.map((x, idx) => (
                  <div className="row" key={idx}>
                    <div className="col-10 align-middle text-start">
                      <OrderProductOptionComponent
                        key={idx}
                        partNumber={x.partNumber}
                        name={x.name}
                        description={x.description}
                      />
                    </div>
                    <div className="col-2">
                      <img
                        className="product-option-image img-fluid"
                        alt=""
                        src={x.imageUrl}
                      ></img>
                    </div>
                  </div>
                ))}
           { lineItem.instructions && lineItem.instructions.length>0 &&
            (
              <div>
            <div className="row mt-2">
            <div className="col line-item-name">Custom Manufacturing Instructions
            </div>
            </div>
            {
            lineItem.instructions?.map((x, idx) => (
            <div className="row highlight">
                <div className="col-10 text-break-line">{x.instruction}
                </div>
            </div>
               ))
            }
            </div>
          )}
            </div>
          </div>
        </div>
        {shipment && (
          <ShipmentInformation shipment={shipment} lineItem={lineItem} />
        )}
        <div className={`col-12 col-sm-${shipment ? '5' : '6'}`}>
          <div className="row mt-2 mt-md-0">
            <div className="col-6">
              <div className="label">Quantity</div>
              <strong>{lineItem.quantity}</strong>
            </div>
            <div className="col-6">
              <div className="label">Part Number</div>
              <strong>{lineItem.partNumber}</strong>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-6">
              {lineItem.serialNumbersEnabled &&
                lineItem.dealerItemIds.length > 0 && (
                  <Fragment>
                    <div className="label">Stock Numbers</div>
                    {lineItem.dealerItemIds.map((dealerItemId, idx) => (
                      <Fragment key={idx}>
                        {idx > 0 && <br />}
                        <strong>{dealerItemId}</strong>
                      </Fragment>
                    ))}
                  </Fragment>
                )}
            </div>
            <div className="col-6">
              { (
                <Fragment>
                  <div className="label">Serial Numbers</div>
                  {lineItem.serialNumbers.map((sn, idx) => (
                    <Fragment key={idx}>
                      {idx > 0 && <br />}
                      <strong>{sn}</strong>{' '}
                      {appConfig.isManagementApp && isAmiUserAuthorizedToManageOrders() && order && !order.isBlackbird && (
                        <button
                          type="button"
                          className="btn btn-link pt-0 pb-0"
                          onClick={() => this.onEditSerialNumber(idx, sn)}
                        >
                          edit
                        </button>
                      )}
                    </Fragment>
                  ))}
                  <SerialNumberModal
                    show={showModal}
                    onHide={this.hide}
                    idx={idx}
                    serialNumber={serialNumber}
                    orderId={order != null ? order.id : null}
                    orderLineItemId={lineItem.id}
                    onChanged={loadOrder}
                  />
                </Fragment>
              )}
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-6">
              {shipment && <ShipViaComponent shipment={shipment} />}
            </div>
            <div className="col-6">
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default OrderShipmentProduct;
